import {
  FETCH_FILTROS,
  GET_FILTROS,
  LIMPIAR_FILTROS,
  UPDATE_FILTROS,
  REMOVE_FILTRO,
} from '../actions/types.js'

const initialState = {
  filtros: { filtros: [], isLoading: false },
  filtros_claves_estadisticas: {
    filtros_claves_estadisticas: [],
    isLoading: false,
  },
  filtros_aplicados: [],
  isLoading: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FILTROS:
      return {
        ...state,
        filtros: { filtros: [], isLoading: true },
        filtros_claves_estadisticas: {
          filtros_claves_estadisticas: [],
          isLoading: true,
        },
      }
    case GET_FILTROS:
      let filtros = {
        filtros: action.payload['filtros'],
        isLoading: false,
      }

      let filtros_claves = {
        filtros_claves_estadisticas: action.payload['filtros_claves'],
        isLoading: false,
      }
      return {
        ...state,
        filtros: filtros,
        filtros_claves_estadisticas: filtros_claves,
      }
    case LIMPIAR_FILTROS:
      return {
        ...state,
        isLoading: false,
        filtros_aplicados: [],
        familia_seleccionada: '',
      }
    case UPDATE_FILTROS:
      return {
        ...state,
        isLoading: false,
        filtros_aplicados: [...state.filtros_aplicados, action.payload],
      }
    case REMOVE_FILTRO:
      let findPos = elem =>
        elem.estadistico === action.payload.estadistico && elem.familia === action.payload.familia

      let aux = state.filtros_aplicados.slice()
      let pos = aux.findIndex(findPos)
      aux.splice(pos, 1)

      return {
        ...state,
        isLoading: false,
        filtros_aplicados: aux,
        familia_seleccionada: '',
      }
    default:
      return state
  }
}
